import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNoSpaces]',
})
export class NoSpacesDirective {
  constructor(private elementRef: ElementRef) {
  }
  @Input() appNoSpaces = false;

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    if (event.cancelable) {
      return;
    }
    const el = this.elementRef.nativeElement;
    if(this.appNoSpaces) {
      const trimmedValue = el.value.replace(/ /ig, '');
      el.value = trimmedValue;
      el.dispatchEvent(new Event('input', {cancelable: true}));
    }
  }
}
